module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-lazyload-23.c55cf1fe.jpg";